import React from 'react'
import { useSnapshot } from 'valtio'
import UtopiaBottomSheetModal from './UtopiaBottomSheetModal'
import { UTOPIA_CGU_SECTIONS, UTOPIA_CGU_UPDATED } from './utopiaCguContent'
import { closeUtopiaCguModal, openUtopiaCguModal, utopiaOverlayState } from './utopiaOverlayState'
import { renderUtopiaModalParagraph } from './utopiaModalParagraph'
import styles from './utopiaLanding.module.css'

export { openUtopiaCguModal }

export default function UtopiaCguModal () {
  const { cguOpen } = useSnapshot(utopiaOverlayState)

  return (
    <UtopiaBottomSheetModal
      active={cguOpen}
      onClose={closeUtopiaCguModal}
      title="Conditions Générales d'Utilisation (CGU)"
      titleId="utopia-cgu-title"
      subtitle="Serveur Minecraft Utopie Serveur"
      meta={`Dernière mise à jour : ${UTOPIA_CGU_UPDATED}`}
      wide
    >
      <p className={styles.cguIntro}>
        Bienvenue sur le serveur Minecraft Utopie Serveur.
        Les présentes Conditions Générales d&apos;Utilisation (CGU) définissent les règles d&apos;accès
        et d&apos;utilisation du serveur, du site associé, ainsi que des services liés.
      </p>
      <p className={styles.cguIntro}>
        En utilisant les services de Utopie Serveur, vous acceptez pleinement ces CGU.
      </p>

      {UTOPIA_CGU_SECTIONS.map(section => (
        <section key={section.title} className={styles.cguSection}>
          <h3 className={styles.cguSectionTitle}>{section.title}</h3>
          {section.paragraphs?.map((p, i) => (
            <p key={i} className={styles.cguParagraph}>{renderUtopiaModalParagraph(p)}</p>
          ))}
          {section.bullets && (
            <ul className={styles.cguList}>
              {section.bullets.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          )}
          {section.subBullets && (
            <ul className={`${styles.cguList} ${styles.cguListSub}`}>
              {section.subBullets.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </UtopiaBottomSheetModal>
  )
}
